import axios from 'axios'
import { Message } from "element-ui"
// import { Loading, Message } from "element-ui"

const config = {
  baseURL: '//gateway.cdeledu.com/doorman/op',
  timeout: 11000,//之前是5000，由于某些学员网络问题，和后台确定，改为11000，后台为10000
  withCredentials: false,
  responseType: 'json',
  xsrfHeaderName: "X-XSRF-TOKEN",
  xsrfCookieName: "XSRF-TOKEN",
  maxContentLength: 2000,
  headers: { 'Content-Type': 'application/json' }
}

const Service = axios.create(config)
// let LoadingInstance = {}

Service.interceptors.request.use(config => {
  // LoadingInstance = Loading.service({ fullscreen: true })
  return config
}, error => {
  // LoadingInstance.close()
  Message.error({ message: '加载超时' })
  return Promise.reject(error)
})

/*
* -7 登录过期
* -6 请求公钥过期
* -13
* */
Service.interceptors.response.use(async (response) => {
  // LoadingInstance.close()
  const { errorCode } = response.data
  if (errorCode === '-7') {
    window.location.href = `//member.chinaacc.com/member/loginAgain.shtm?validateLogin=n&gotoURL=${ encodeURIComponent(process.env.VUE_APP_RELEASE_URL) }`
  } else if (errorCode === '-6' || errorCode === '-13') {
    Message.error({ message: `${ response.data.errorMsg },请刷新重试` })
    response.data = { success: false, reRequest: true }
  }
  // LoadingInstance.close()
  return response
}, error => {
  // LoadingInstance.close()
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        error.message = '错误请求'
        break
      case 401:
        error.message = '未授权，请重新登录'
        break
      case 403:
        error.message = '拒绝访问'
        break
      case 404:
        error.message = '请求错误，未找到该资源'
        break
      case 405:
        error.message = '请求方法为允许'
        break
      case 408:
        error.message = '请求超时'
        break
      case 500:
        error.message = '服务端错误'
        break
      case 501:
        error.message = '网络未实现'
        break
      case 502:
        error.message = '网络错误'
        break
      case 503:
        error.message = '服务不可用'
        break
      case 504:
        error.message = '网络超时'
        break
      case 505:
        error.message = 'http版本不支持该请求'
      // eslint-disable-next-line no-fallthrough
      default:
        error.message = `连接错误${ error.response.status }`
    }
  } else {
    error.message = '网络出现问题，请稍后再试'
  }
  Message.error({ message: error.message })

  return Promise.reject(error)
})

export default Service
